import React from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';

import { dictionaryItem, getDictionaryItem } from '../../hocs/withDictionary';
import { Text } from '../ui';
import Price from '../Price';
import IbePropTypes from '../../IbePropTypes';
import { PoaPrice } from './ListingItem.style';

const ListingItemPricing = ({
  isTours,
  hasPrice,
  client,
  tour,
  memberPrice,
  index,
  priceSuffix,
  isOpen,
  loadingPrices,
  showPOA,
}) => {
  if (hasPrice) {
    return (
      <Price
        amount={memberPrice || tour?.fromPrice}
        prefix={getDictionaryItem(
          client,
          'ListingItem__ToursPricePrefix__Text',
        )}
        testingId={`search-results-campsite__listing-item-${index}__price`}
        suffix={
          isTours ? (tour?.fromPriceSuffix || '').toLowerCase() : priceSuffix
        }
      />
    );
  }
  if (showPOA) {
    return <PoaPrice dictionary={dictionaryItem('ListingItem', 'PriceOnAsking')} />;
  }
  return (
    <>
      {loadingPrices ? (
        <Text
          size="1rem"
          dictionary={dictionaryItem('ListingItem', 'PriceLoading')}
        />
      ) : (
        <>
          {isOpen ? (
            <Text
              size="1rem"
              dictionary={dictionaryItem('ListingItem', 'PriceUnavailable')}
            />
          ) : (
            <Text
              size="1rem"
              dictionary={dictionaryItem('ListingItem', 'SiteClosed')}
            />
          )}
        </>
      )}
    </>
  );
};

ListingItemPricing.propTypes = {
  isTours: PropTypes.bool,
  hasPrice: PropTypes.bool,
  tour: PropTypes.shape(IbePropTypes.tour),
  client: PropTypes.shape(IbePropTypes.client),
  memberPrice: PropTypes.number,
  index: PropTypes.number.isRequired,
  priceSuffix: PropTypes.string,
  isOpen: PropTypes.bool,
  loadingPrices: PropTypes.bool,
  showPOA: PropTypes.bool,
};

ListingItemPricing.defaultProps = {
  isTours: false,
  hasPrice: false,
  tour: { },
  client: { },
  memberPrice: null,
  priceSuffix: '',
  isOpen: false,
  loadingPrices: true,
  showPOA: false,
};

export default withApollo(ListingItemPricing);
